import React from 'react';

/*
 * Compact data table. Wrap in <Card> and a horizontal scroller:
 *   <Card><div className="overflow-x-auto"><Table>…</Table></div></Card>
 * On phones prefer a stacked list of rows instead of a wide table.
 */
export const Table: React.FC<React.TableHTMLAttributes<HTMLTableElement>> = ({ className = '', ...props }) => (
  <table className={`w-full border-collapse text-left text-[13px] ${className}`} {...props} />
);

export const THead: React.FC<React.HTMLAttributes<HTMLTableSectionElement>> = ({ className = '', ...props }) => (
  <thead className={`border-b border-neutral-200/70 ${className}`} {...props} />
);

export const TBody: React.FC<React.HTMLAttributes<HTMLTableSectionElement>> = ({ className = '', ...props }) => (
  <tbody className={`divide-y divide-neutral-100 ${className}`} {...props} />
);

export const TH: React.FC<React.ThHTMLAttributes<HTMLTableCellElement>> = ({ className = '', ...props }) => (
  <th className={`h-9 whitespace-nowrap px-4 text-[12px] font-normal text-neutral-400 ${className}`} {...props} />
);

export const TR: React.FC<React.HTMLAttributes<HTMLTableRowElement> & { interactive?: boolean }> = ({
  interactive = false,
  className = '',
  ...props
}) => (
  <tr
    className={`transition-colors ${interactive ? 'cursor-pointer hover:bg-neutral-50' : ''} ${className}`}
    {...props}
  />
);

export const TD: React.FC<React.TdHTMLAttributes<HTMLTableCellElement>> = ({ className = '', ...props }) => (
  <td className={`h-11 px-4 align-middle text-ink ${className}`} {...props} />
);
